import styled from "styled-components";

import { IconButton } from "./controls";
import { Icon } from "./Icon";

/** Back to the list, on a phone. A tablet shows the list next to it, so it doesn't need one. */
export function PhoneBack({ label, onClick }: { label: string; onClick(): void }) {
    return (
        <Back aria-label={label} onClick={onClick}>
            <Icon name="back" />
        </Back>
    );
}

const Back = styled(IconButton)`
    margin-left: -8px;

    @media (min-width: 700px) {
        display: none;
    }
`;
